module.exports = __webpack_public_path__ + "static/media/Biondina.806d6421.png";